import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";
import { API_BASE_URL, FileDto } from "@shared/service-proxies/service-proxies";

@Injectable()
export class FileDownloadService {
  private http: HttpClient;
  private baseUrl: string;
  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) { }
  downloadTempFile(file: FileDto) {
    const url =
      AppConsts.remoteServiceBaseUrl +
      "/api/File/DownloadTempFile?fileType=" +
      file.fileType +
      "&fileToken=" +
      file.fileToken +
      "&fileName=" +
      file.fileName;
    location.href = url; //TODO: This causes reloading of same page in Firefox
  }

  downloadInvoiceXml(invoiceId: string) {
    const url = `${AppConsts.remoteServiceBaseUrl}/api/Invoice/downloadInvoiceXml?invoiceId=${invoiceId}`;
    this.http.get(url, { responseType: 'blob' }).subscribe(result => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(result);
      a.href = objectUrl;
      a.download = `invoice-${invoiceId}.xml`;
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }
}
